import { Outlet } from "react-router-dom";

export const VehiclesPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
